import React, { useState } from 'react';
import ExportInventory from './screens/ExportInventory';
import InventoryScreen from './screens/InventoryScreen';
import VendorSettings from './screens/VendorSettings';
import ZeroOut from './screens/ZeroOut';

function Inventory() {
  const [screen, setScreen] = useState('inventory');

  const screenMap = {
    inventory: <InventoryScreen />,
    exportInventory: <ExportInventory />,
    zeroOut: <ZeroOut />,
    vendorSettings: <VendorSettings />,
  };
  const menuList = [
    {
      name: 'Inventory',
      subMenus: [
        { name: 'inventory', title: 'Inventory' },
        { name: 'exportInventory', title: 'Export Inventory' },
        { name: 'zeroOut', title: 'Zero Out' },

        { name: 'vendorSettings', title: 'Vendor Settings' },
      ],
    },
  ];
  return (
    <div className="bg-[#0a1929] w-full h-full flex flex-row justify-start">
      <div className="h-full border-r border-r-[#81848f3d] w-[320px] my-5">
        {menuList?.map((section) => {
          return (
            <div key={section?.name}>
              <div className="flex items-center pl-6 mt-6 py-3 text-gray-500 font-semibold mx-6 uppercase text-sm">
                {section?.name}
              </div>
              {section?.subMenus?.map((sub) => {
                return (
                  <div
                    key={sub?.name}
                    onClick={() => setScreen(sub?.name)}
                    className={`flex items-center cursor-pointer py-1 pl-6  font-semibold mx-6 my-2  rounded-md ${
                      screen === sub?.name
                        ? 'text-white bg-[#0f243c]'
                        : 'hover:text-white hover:bg-[#0f243c] text-gray-300'
                    }`}
                  >
                    {sub?.title}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
      <div className="ml-8 w-full overflow-y-scroll h-screen gray-small-scroll">
        {screenMap[screen as keyof typeof screenMap]}
      </div>
    </div>
  );
}

export default Inventory;
